import { Injectable } from '@angular/core';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, catchError, map, throwError } from 'rxjs';
import { FormlyBaseConfigService } from '../../../../services/formly/formly-base-config/formly-base-config.service';
import { LandUseClassService } from '../land-use-class/land-use-class.service';
import {
  LandUseClassFormConfig,
  LandUseClassFormControlName,
  LandUseClassFormModel,
} from './land-use-class-form.model';

@Injectable()
export class LandUseClassFormService extends FormlyBaseConfigService<
  LandUseClassFormConfig,
  LandUseClassFormModel,
  LandUseClassFormControlName
> {
  constructor(
    private translateService: TranslateService,
    private landUseClassService: LandUseClassService,
  ) {
    super();
  }

  getFormConfig(): Observable<{
    fields: FormlyFieldConfig[];
    options?: FormlyFormOptions;
  }> {
    const fields = [
      {
        key: LandUseClassFormControlName.LandUseClass,
        type: 'formly-mat-tree-select-type',
        wrappers: ['gk-common-bootstrap-form-field'],
        props: {
          options: this.landUseClassService.get(),
          required: true,
          validationMessages: {
            required: this.translateService.stream('FIELD_REQUIRED'),
          },
          attributes: {
            class: 'form-select form-select-sm',
          },
        },
        expressions: {
          'props.disabled': 'field.options?.formState.disableGroup',
        },
      },
    ];

    return this.getFieldsWithCustomConfig(fields, this.getLabel).pipe(
      map((fieldsWithCustomConfig) => {
        return {
          fields: fieldsWithCustomConfig,
        };
      }),
      catchError((error) => {
        console.error(error);

        return throwError(() => error);
      }),
    );
  }

  getLabel = (controlKey: string): Observable<string> => {
    return this.translateService.stream(
      `LAND_USE_CLASS_FORM.${controlKey.toUpperCase()}`,
    );
  };
}
